import * as React from 'react';

export interface ICountryStateRowProps {
  countryState: GQL.ICountryState;
  onClick?: Function;
}

export default class CountryStateRow extends React.Component<ICountryStateRowProps> {

  public render() {
    const { countryState } = this.props;

    return (
      <div
        onClick={(e: any) => {
          if (this.props.onClick) {
            this.props.onClick(e);
          }
        }}
        style={{ cursor: this.props.onClick ? 'pointer' : '' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {`${countryState.name}${countryState.vatRate ? ` (${countryState.vatRate} %)` : ``}`}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Countries/CountryDetail/components/CountryStates/components/CountryStateRow.tsx